import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { AppService } from 'src/app/app.service';
import { APP_Constants } from 'src/app/app.constant';
import { DhlFormControlAutocomplete } from '../../models/dhl-form-control-autocomplete';
import { debounceTime } from 'rxjs/operators';
import { ModalService } from 'src/app/common/modal/modal.service';
import { Subject } from 'rxjs';
import { ErrorsConfig } from 'src/app/common/configuration/errors.config';
import { CommonConfig } from 'src/app/common/configuration/common.config';
import { Modal } from 'src/app/common/modal/modal';

@Component({
    selector: 'app-form-field-autocomplete',
    templateUrl: './form-field-autocomplete.component.html',
    styleUrls: ['./form-field-autocomplete.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldAutoCompleteComponent implements OnInit {

  @Input() configData: DhlFormControlAutocomplete;
  @Input() frmGroup: UntypedFormGroup;

  autocompleteList = [];
  noItemFound  
  autoCompleteMetaData;

  noItemFoundError;
  selectFromListError;
  requiredError;
  specialCharError;
  
  searchTerms = new Subject<string>();
  validationType: string = '';
  excludeItem: string = '';
  selection;
  timeout = null;
  
  color: String = 'primary';
  mode: String = 'indeterminate';

  constructor(private appService: AppService, private modalService: ModalService) {    
  }

  ngOnInit() {
    console.log(this.frmGroup);
    console.log(this.configData);

    this.autoCompleteMetaData = new DhlFormControlAutocomplete(this.configData);

    this.noItemFoundError = ErrorsConfig.autocomplete.notFound;
    this.selectFromListError = ErrorsConfig.autocomplete.selectFromList;
    this.requiredError = ErrorsConfig.required;
    this.specialCharError = ErrorsConfig.input.specialCharacter;

    this.searchTerms.pipe(debounceTime(CommonConfig.LOCATION_SEARCH_TIMEOUT))
      .subscribe(term => {
        this.makeApicall(term);
        console.log(term);
      }
    )

    this.configData.validation.forEach(element => {
      if(element === "NoSpecialCharacter"){
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp('^((?![$<>?%&*#!~`]).)*$')));
      }    
      if(element === 'hidden'){
        if(this.configData['dependentColumn'] && this.frmGroup.get(this.configData['dependentColumn']).value.value === 'Y'){          
          this.frmGroup.get(this.configData.name)['hidden'] = false;          
        } else{
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.frmGroup.get(this.configData.name).reset();        
        }        
      }
    }, this); 
  }

  progressBar: boolean = false;
  makeApicall(searchText){
    this.progressBar = true;
    this.appService.makeHttpGetRequest(this.autoCompleteMetaData.apiUrl+ localStorage.getItem('customerCode') +
      '&userId=' + localStorage.getItem('userName') +
      "&searchString="+searchText.toUpperCase() +            
      '&exclude=' + this.excludeItem)
    .subscribe(data=>{
      this.progressBar = false;
      if(data['message'].statusCode === APP_Constants.SUCCESS_CODE){
        this.autocompleteList = data[this.autoCompleteMetaData.responseListName];            
        this.frmGroup.get(this.configData.name)['listArray'] = [];
        this.autocompleteList.map((item)=>{        
          let text = '';
          text = item[this.autoCompleteMetaData.primaryText[0]];
          if(this.autoCompleteMetaData.primaryText[1]){
            text = text +' - '+item[this.autoCompleteMetaData.primaryText[1]];
          }      
          this.frmGroup.get(this.configData.name)['listArray'].push(text);
        })
      }else if(data['message'].statusCode === APP_Constants.ERROR_CODE){    
        this.progressBar = false;        
        this.noItemFound = true;
        this.frmGroup.get(this.configData.name)['listArray'] = [];
        this.autocompleteList = [];
        // this.configData.validation.forEach(elem=>{
        //   if(elem === 'Select from list'){
        //     this.frmGroup.get(this.configData.name).setErrors({'404': {'message':''}});
        //   }
        // }, this);           
      }          
    }, 
    (err) => {
      this.progressBar = false;
      let modal = new Modal({
        action: false, name: 'autocomplete', title: 'Autocomplete', description: err.message, actionButtonText: ''
      });
      this.modalService.createModalBox(modal, err.status);      
    });
  }  

  fetchAutocompleteList(e){
    if(this.frmGroup.get(this.configData.name).value !== ''){   
      if(this.frmGroup.get(this.configData.name)['listArray'] && this.frmGroup.get(this.configData.name)['listArray'].indexOf(this.frmGroup.get(this.configData.name).value) > -1 || 
      (this.autocompleteList.length > 0 && this.selection === this.frmGroup.get(this.configData.name).value ) ) {
        return ;
      }else{
        this.selection = this.frmGroup.get(this.configData.name).value;
      }
    }    

    this.frmGroup.get(this.configData.name)['secondaryText'] = '';
    this.noItemFound = false;
    let searchText = e.currentTarget.value;
    clearTimeout(this.timeout);

    if(searchText.length >= this.autoCompleteMetaData.minSearchChar && searchText != null){      
      this.autocompleteList = [];          
      this.searchTerms.next(searchText);
    }else{
      this.autocompleteList = [];      
      this.frmGroup.get(this.configData.name)['listArray'] = [];
    }
  }

  // select from list validation for autocomplete
  requireMatch(){
    const selection: any = this.frmGroup.get(this.configData.name).value;
    if(selection !== ''){      
      if (this.frmGroup.get(this.configData.name)['listArray']  && this.frmGroup.get(this.configData.name)['listArray'].indexOf(selection) < 0) {
        this.frmGroup.get(this.configData.name).setErrors({'selectFromList': true});
      }      
    }    
  } 

  selectedItem(e, item){
    this.noItemFound = false;  
    this.autocompleteList = [];
  }

  getValue(item){
    let text = '';
    text = item[this.autoCompleteMetaData.primaryText[0]];
    if(this.autoCompleteMetaData.primaryText[1]){
      text = text +' - '+item[this.autoCompleteMetaData.primaryText[1]];
    }
    return text;
  }  
}
